var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFurniture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sofa-Double--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sofa Double Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.23 8.13a3.5 3.5 0 0 1 3.24 3.06 0.5 0.5 0 0 0 0.5 0.43h4.78a0.5 0.5 0 0 0 0.5 -0.5v-5a0.75 0.75 0 0 1 1.5 0v5a0.5 0.5 0 0 0 0.5 0.5H18a0.5 0.5 0 0 0 0.5 -0.43 3.51 3.51 0 0 1 3.11 -3 0.4 0.4 0 0 0 0.36 -0.4v-0.17a4.51 4.51 0 0 0 -4.5 -4.5H6.5A4.51 4.51 0 0 0 2 7.62v0.26a0.25 0.25 0 0 0 0.23 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.63a2 2 0 0 0 -2 2v1a0.5 0.5 0 0 1 -0.5 0.5h-15a0.5 0.5 0 0 1 -0.5 -0.5v-1a2 2 0 0 0 -4 0v4a2.47 2.47 0 0 0 1.46 2.25 0.51 0.51 0 0 1 0.29 0.46v1.29a1.25 1.25 0 0 0 2.5 0v-1a0.5 0.5 0 0 1 0.5 -0.5h14.5a0.5 0.5 0 0 1 0.5 0.5v1a1.25 1.25 0 0 0 2.5 0v-1.29a0.51 0.51 0 0 1 0.29 -0.46A2.47 2.47 0 0 0 24 15.63v-4a2 2 0 0 0 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFurniture);
export default ForwardRef;